<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'moviasEventRuleCrud'"
            :crudName="$t('Configurações de eventos')"
            :newText="$t('Add') + '  ' + $t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import {
  criticalityBadge, criticalityLabel, describeCondition, fieldsByKey,
} from "./moviasEvents";

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      table: "moviasEventRuleTable",
      url: "",
      columns: ["id", "name", "movias_event_name", "conditions", "criticality", "active", "actions"],
      tableData: ["id", "name", "movias_event_name", "conditions", "criticality", "active"],
      endPoint: "moviasEventRules",
      dataForm: {},
      fields: {},
    };
  },
  created() {
    axios.get(`${this.$store.state.api}movias/event-fields`)
        .then(response => {
          this.fields = fieldsByKey(response.data)
        })
        .catch(error => this.$error(error));
  },
  computed: {
    options() {
      return {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "criticality", "active"],
        sortable: ["id", "name", "criticality"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("Id"),
          name: this.$t("name"),
          movias_event_name: this.$t("Evento do Movias"),
          conditions: this.$t("Condições"),
          criticality: this.$t("Criticidade"),
          active: this.$t("Ativo"),
          actions: this.$t("action"),
        },
        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          criticality: [
            { id: "low", text: criticalityLabel("low") },
            { id: "medium", text: criticalityLabel("medium") },
            { id: "high", text: criticalityLabel("high") },
          ],
          active: [
            { id: 1, text: this.$t("Sim") },
            { id: 0, text: this.$t("Não") },
          ],
        },
        templates: {
          movias_event_name: (h, row) => row.movias_event_id
              ? `${row.movias_event_id} — ${row.movias_event_name || ""}`
              : this.$t("Qualquer evento"),
          conditions: (h, row) => (row.conditions || []).map(c => describeCondition(c, this.fields)).join(" e ") || "—",
          criticality: (h, row) => h("span", { class: ["badge", criticalityBadge(row.criticality)] },
              criticalityLabel(row.criticality)),
          active: (h, row) => h("span", { class: ["badge", row.active ? "badge-success" : "badge-secondary"] },
              row.active ? this.$t("Sim") : this.$t("Não")),
        },
        requestFunction: function (data) {
          const query = this.$parent.$parent.$parent.query(data.query);
          const requestData = { params: { ...data, query: "" } };

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      };
    },
  },
  methods: {
    query(query) {
      let filters = "";

      $.each(query, function (index, value) {
        if (value === "" || value === null || value === undefined) return;
        filters += index + "=" + encodeURIComponent(value) + "&";
      });

      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
